module.exports = __webpack_public_path__ + "img/intel_write.a831574c.png";